import React, { Component } from 'react'
import Menu from './includes/Menu'
import { Grid } from '../../../node_modules/@material-ui/core';
import Img01 from '../assets/images/news-20161218001-img01.png';

const lang = '';

class News20161218001 extends Component {
  constructor(props) {
    super(props);
    this.lang = (props.lang) ? props.lang : '';
  }

  componentDidMount() {
    document.title = this.getLangText({
      'tc': '新聞中心',
      'sc': '新闻中心',
      'en': 'News Center'
    });
  }

  getLangText(langJson) {
    return (this.lang) ? langJson[this.lang] : langJson['tc'];
  }

  render(){
    return(
      News20161218001JSX(this)
    );
  }
}

const News20161218001JSX = (ctx) => (
  <div className={ (ctx.lang === 'en' ? 'en' : '') }>
    <Menu lang={ ctx.lang } />
  
    <div className='main-content-container'>
      <div className='main-content-inner-wrapper newsdt'>
        <Grid container spacing={0}>
          <Grid item id='page-title'>
            <span>
              {
                ctx.getLangText({
                    'tc': '新聞',
                    'sc': '新闻',
                    'en': 'News'
                })
              }
            </span>
          </Grid>
        </Grid>
        <div style={{clear:'both'}}></div>

        <div className='newsdt-container'>
          <Grid container spacing={0} className='newsct' id='grid-section' justify='center'>
            <Grid item xs={12} sm={8} md={10} className='news-title theme-color'>
              <span>
                {
                  ctx.getLangText({
                      'tc': '鑫匯寶貴金屬榮獲2016傑出金商增值服務大獎',
                      'sc': '鑫汇宝贵金属荣获2016杰出金商增值服务大奖',
                      'en': 'Xinhuibao Precious Metals won the China Financial Annual Champion Best Precious Metals Trading Platform Awards'
                  })
                }
              </span>
            </Grid>
            <Grid item xs={12} sm={4} md={2} className='news-date'>
              <span>2016.12.18</span>
            </Grid>
          </Grid>

          <Grid item style={{width:'100%', marginBottom:'30px'}}><hr/></Grid>

          <Grid container spacing={0} className='content-container'>
            <Grid item>
              <p>
                {
                  ctx.getLangText({
                      'tc': `近日，匯寶資本集團旗下鑫匯寶貴金屬有限公司有幸參加由《Let's go投資先機》雜誌、知名財經機構以及各大傳媒聯合舉辦的2016年最具投資價值上市公司頒獎典禮（Best Investment Value Award 2016以下間稱BIVA2016）以及貴金屬行業服務大獎（Bullion Value-Added Service Award）。香港鑫匯寶貴金屬有限公司在此次盛典中榮獲2016傑出金商增值服務大獎。`,
                      'sc': `近日，汇宝资本集团旗下鑫汇宝贵金属有限公司有幸参加由《Let's go投资先机》杂誌、知名财经机构以及各大传媒联合举办的2016年最具投资价值上市公司颁奖典礼（Best Investment Value Award 2016以下间称BIVA2016）以及贵金属行业服务大奖（Bullion Value-Added Service Award）。香港鑫汇宝贵金属有限公司在此次盛典中荣获2016杰出金商增值服务大奖。`,
                      'en': `Xinhuibao Precious Metals Co., Ltd., a subsidiary of Huibao Capital Group, fortunate to have join the awards ceremony of the 2016 Most Investing Value Listed Company by the "Let's Go Investment Opportunity" magazine, well-known materials and organizations and major media (Best Investment Value Award 2016 below) In the event of BIVA2016) and Precious Metals Merchants Value-Added Service Award, the industry model Hong Kong Xinhuibao Precious Metals Co., won the 2016 Outstanding Precious Metals Merchants Value-added Service Award in this ceremony.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `BIVA已經成功舉辦三屆，今年是第四屆。評選委員會官方負責人稱，之所以設立此獎項，一來是為了表彰獲獎公司嚴格控制合規內容以及高水平合規要求的做法。二來鼓勵企業透過各種正規途徑及方式提高企業的價值。本屆BIVA獎項分為100億港元、100億至300億港元、300億三個等級。經過層層篩選，在綜合上一年度業績、息率回報、資產折讓、業務增長潛力以及業務模式穩健性等因素的基礎上，評選委員對各大金商的業界服務進行嚴格的綜合測評。綜合各種測評結果進行排名，香港鑫匯寶貴金屬有限公司脫穎而出，獲得2016傑出金商增值服務大獎。`,
                      'sc': `BIVA已经成功举办三届，今年是第四届。评选委员会官方负责人称，之所以设立此奖项，一来是为了表彰获奖公司严格控制合规内容以及高水平合规要求的做法。二来鼓励企业透过各种正规途径及方式提高企业的价值。本届BIVA奖项分为100亿港元、100亿至300亿港元、300亿三个等级。经过层层筛选，在综合上一年度业绩、息率回报、资产折让、业务增长潜力以及业务模式稳健性等因素的基础上，评选委员对各大金商的业界服务进行严格的综合测评。综合各种测评结果进行排名，香港鑫汇宝贵金属有限公司脱颖而出，获得2016杰出金商增值服务大奖。`,
                      'en': `BIVA has been successfully held for three times. This year is the fourth year. The official person in charge of the selection committee said that the award was established in recognition of the award-winning company's strict control of compliance content and high-level compliance requirements. Means to improve the value of the company. The current BIVA awards are divided into 10 billion Hong Kong dollars, 10 billion to 30 billion Hong Kong dollars, and 30 billion yuan. Based on the factors of the previous year's performance, interest rate return, asset discount, business growth potential and business model stability, the selection committee conducted a rigorous comprehensive evaluation of the industry services of the major Precious Metals merchants. The results of various evaluations were ranked, and the industry model Hong Kong Xinhui Precious Metal Co., Ltd. stood out and won the 2016 Outstanding Precious Metals Merchants Value-added Service Award.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `據悉，香港鑫匯寶貴金屬有限公司是香港金銀業貿易場106號AA類（最高類）行員，嚴格遵守行業規範的鑫匯寶貴金屬以貴金屬現貨投資等金融業務為主要經營項目。自成立之初，鑫匯寶始終以互聯網為依托，不斷提高交易策略水平和研發水平，並使用快捷、安全系數高的資金管理系統、內容豐富的學習資料以及全天候的精英團隊諮詢服務等都是鑫匯寶被稱為"投資者進行貴金屬交易首選平台"的佐證。在保證客戶資金安全的前提下，不斷提升客戶交易體驗、提高專業品質、樹立優秀服務品牌，務求為客戶帶來更完美的投資感受。`,
                      'sc': `据悉，香港鑫汇宝贵金属有限公司是香港金银业贸易场106号AA类（最高类）行员，严格遵守行业规范的鑫汇宝贵金属以贵金属现货投资等金融业务为主要经营项目。自成立之初，鑫汇宝始终以互联网为依托，不断提高交易策略水平和研发水平，并使用快捷、安全系数高的资金管理系统、内容丰富的学习资料以及全天候的精英团队谘询服务等都是鑫汇宝被称为"投资者进行贵金属交易首选平台"的佐证。在保证客户资金安全的前提下，不断提升客户交易体验、提高专业品质、树立优秀服务品牌，务求为客户带来更完美的投资感受。`,
                      'en': `Hong Kong Xinhuibao Precious Metals Co., Ltd. is a member of The Chinese Gold & Silver Exchange Society (member No. 106) and holds AA types of market trading license. precious metal investment is the main business we strict compliance with industry norms. Since its inception,  Xinhuibao Precious Metals has always relied on the Internet to continuously improve its trading strategy and R&D level. It has a convenient and high-capacity fund management system, rich learning materials and all-day elite team consulting services. We known as the "investor's preferred platform for precious metals trading". Under the premise of ensuring the safety of client funds, we will continuously improve the customer transaction experience, improve professional quality, and establish an excellent service brand, in order to bring a more perfect investment experience to customers.`
                  })
                }
              </p>
              <p>
                {
                  ctx.getLangText({
                      'tc': `香港鑫匯寶貴金屬有限公司相關負責人稱，此次獲獎不僅是對鑫匯寶成員多年努力結果的肯定，也是對鑫匯寶這個優良交易平台和服務水平的肯定。未來，鑫匯寶將再接再厲，不斷提升自身的技術水平及服務水平，與廣大投資者一起把握經濟形勢、共享發展盛宴。BIVA2016在一片熱烈的掌聲中落下帷幕，脫穎而出的鑫匯寶備受矚目。很多貴金屬投資者尤其是選擇鑫匯寶的投資者對此次獎項的頒發表示由衷的肯定。在他們看來，鑫匯寶獲獎實至名歸。註重細節、品質與創新的鑫匯寶正在引領貴金屬交易新風尚。`,
                      'sc': `香港鑫汇宝贵金属有限公司相关负责人称，此次获奖不仅是对鑫汇宝成员多年努力结果的肯定，也是对鑫汇宝这个优良交易平台和服务水平的肯定。未来，鑫汇宝将再接再厉，不断提升自身的技术水平及服务水平，与广大投资者一起把握经济形势、共享发展盛宴。BIVA2016在一片热烈的掌声中落下帷幕，脱颖而出的鑫汇宝备受瞩目。很多贵金属投资者尤其是选择鑫汇宝的投资者对此次奖项的颁发表示由衷的肯定。在他们看来，鑫汇宝获奖实至名归。注重细节、品质与创新的鑫汇宝正在引领贵金属交易新风尚。`,
                      'en': `Hong Kong Xinhuibao Precious Metals Co., Ltd. the relevant person in charge said that Xinhuibao's outstanding Precious Metals value-added service award for two consecutive years is not only an affirmation of the results of many years of efforts of Xinhuibao members, but also an affirmation of Xinhuibao, an excellent trading platform and service level. In the future, Xinhuibao will make persistent efforts to continuously improve its technical level and service level, and grasp the economic situation and share development together with investors. BIVA2016 came to an end in the applause of the event, and Xinhuibao, which stood out from the crowd, attracted much attention. Many precious metal investors, especially investors who chose Xinhuibao, expressed their sincere affirmation to the award. In their view, Xinhuibao's awards are truly deserved. Xinhuibao, which pays attention to detail, quality and innovation, is leading the new trend of precious metals trading.`
                  })
                }
              </p>
            </Grid>
            <Grid container spacing={0} justify='center'>
              <Grid item>
                <img src={Img01} style={{ display:'inline-block', verticalAlign:'middle', width:'100%', height:'100%'}} />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  </div>
)

export default News20161218001



// WEBPACK FOOTER //
// ./src/components/pages/PC20161218001.js